import React, { useState } from "react";
import { useAtom } from "jotai";
import { Box, Stack, Typography } from "@mui/material";
import { ThemeProvider, useTheme } from "@mui/material/styles";
import { DialogTheme } from "../../styles/DialogTheme";
import ClientUserInfoModal from "../ClientUserInfoModal";
import {
    mbxUserAtom,
    isMbxUserProvider,
    updateClientInVisibleBookingsAtom,
    companyProviderRestrictionConfigAtom,
    isMbxUserVerifiedStaff
} from "../../atoms/atoms";
import {
    selectedTabAtom,
    selectedBookingIdAtom,
    selectedBookingAtom
} from "../../atoms/bookingsTable";

export const ClientCard = ({
    bookingId,
    clientId,
    isClientActive,
    clientUserId,
    combinedName,
    clientFirstName,
    clientLastName,
    clientEmail,
    clientAddress,
    clientPhoneNumber,
    clientHomePhone,
    clientNotes,
    clientDefaultPartialCC,
    clientRegistered,
    clientUserRole
}) => {
    const [mbxUser] = useAtom(mbxUserAtom);
    const [isVerifiedStaff] = useAtom(isMbxUserVerifiedStaff);
    const [isProviderLoggedIn] = useAtom(isMbxUserProvider);
    const [selectedTab] = useAtom(selectedTabAtom);
    const [, setSelectedBookingId] = useAtom(selectedBookingIdAtom);
    const [selectedBooking] = useAtom(selectedBookingAtom);
    const [, updateClientInVisibleBookings] = useAtom(
        updateClientInVisibleBookingsAtom
    );
    const [providerRestrictionConfig] = useAtom(
        companyProviderRestrictionConfigAtom
    );
    const [showClientInfoDialog, setShowClientInfoDialog] = useState(false);
    const theme = useTheme();

    const handleCloseClientInfoDialog = () => {
        setShowClientInfoDialog(false);
    };

    const handleSaveClientUpdates = (id, clientUpdatesObj) => {
        console.log("Bana clientUpdatesObj: ", clientUpdatesObj);
        console.log("Bana selectedBooking: ", selectedBooking);

        const updatedBookingData = {
            clientId: clientUserId,
            client: {
                ...selectedBooking.client,
                defaultpartialcc:
                    clientUpdatesObj.defaultPartialCC ||
                    selectedBooking.client.defaultpartialcc,
                Notes: clientUpdatesObj.newNotes
                    ? JSON.stringify(clientUpdatesObj.newNotes)
                    : selectedBooking.client.Notes,
                user: {
                    ...selectedBooking.client.user,
                    active:
                        clientUpdatesObj.active ||
                        selectedBooking.client.user.active,
                    firstname:
                        clientUpdatesObj.firstName ||
                        selectedBooking.client.firstname,
                    lastname:
                        clientUpdatesObj.lastName ||
                        selectedBooking.client.lastname,
                    mobilephone:
                        clientUpdatesObj.phoneNumber ||
                        selectedBooking.client.mobilephone,
                    emailaddress:
                        clientUpdatesObj.emailAddress ||
                        selectedBooking.client.emailaddress,
                    addressoneline:
                        clientUpdatesObj.address ||
                        selectedBooking.client.addressoneline
                }
            }
        };
        updateClientInVisibleBookings(updatedBookingData);
    };

    return (
        <Box
            sx={{
                display: "flex",
                gap: "1.2rem",
                alignItems: "center"
            }}
        >
            <Stack>
                {isVerifiedStaff ||
                (isProviderLoggedIn &&
                    providerRestrictionConfig.canProviderSeeClientName) ? (
                    <Typography
                        sx={{
                            maxWidth: {
                                md: "150px",
                                lg: "230px"
                            },
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            pointerEvents: "auto !important",
                            fontWeight: 500,
                            color: "black",
                            textDecoration: "underline",
                            "&:hover": {
                                cursor: "pointer"
                            }
                        }}
                        variant="condensed"
                        onClick={() => {
                            setSelectedBookingId(bookingId);
                            setShowClientInfoDialog(true);
                        }}
                    >
                        {combinedName}
                    </Typography>
                ) : (
                    <Typography
                        sx={{
                            maxWidth: {
                                md: "150px",
                                lg: "230px"
                            },
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            pointerEvents: "auto !important",
                            fontWeight: 500,
                            color: "black !important",
                            textDecoration: "underline",
                            "&:hover": {
                                cursor: "pointer"
                            }
                        }}
                        variant="condensed"
                        onClick={() => {
                            setSelectedBookingId(bookingId);
                            setShowClientInfoDialog(true);
                        }}
                    >
                        {`${clientFirstName} ${
                            clientLastName.trim().charAt(0) + "."
                        }`}
                    </Typography>
                )}
                {(isVerifiedStaff ||
                    (isProviderLoggedIn &&
                        providerRestrictionConfig.canProviderSeeClientEmail)) && (
                    <Typography
                        variant="condensed"
                        sx={{
                            maxWidth: {
                                md: "150px",
                                lg: "230px"
                            },
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                        }}
                    >
                        {clientEmail}
                    </Typography>
                )}
                {(isVerifiedStaff ||
                    (isProviderLoggedIn &&
                        providerRestrictionConfig.canProviderSeeClientPhone)) &&
                    selectedTab !== "past" && (
                        <Typography
                            variant="condensed"
                            sx={{
                                maxWidth: {
                                    md: "150px",
                                    lg: "230px"
                                },
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis"
                            }}
                        >
                            {clientPhoneNumber}
                        </Typography>
                    )}
            </Stack>

            <ThemeProvider theme={DialogTheme(theme)}>
                <ClientUserInfoModal
                    isOpen={showClientInfoDialog}
                    onClose={handleCloseClientInfoDialog}
                    loggedInUser={mbxUser}
                    onSave={handleSaveClientUpdates}
                    mode={"EDIT"}
                    isGuestOnly={true}
                    focusNotes={true}
                    clientUser={{
                        id: clientId,
                        active: isClientActive,
                        registered: clientRegistered,
                        userId: clientUserId,
                        userRole: clientUserRole,
                        firstName: clientFirstName,
                        lastName: clientLastName,
                        emailAddress: clientEmail,
                        phone: clientPhoneNumber,
                        clientNotes: clientNotes,
                        // contactConsent: clientContactConsent,
                        defaultPartialCC: clientDefaultPartialCC,
                        addressOneLine: clientAddress
                    }}
                />
            </ThemeProvider>
        </Box>
    );
};
